import { graphql, useStaticQuery } from "gatsby";

interface ReferenciaMultimedia {
    audioUrl: null;
    autor: null | string;
    categoriaMultimedia: string;
    contentful_id: string;
    createdAt: Date;
    descripcion: {
        raw: string;
    } | null;
    imagenPrincipal: {
        file: {
            url: string;
            contentType: string;
            fileName: string;
        };
    };
    tematica: string;
    textoIntroductorio: string;
    tiempoLectura: null | string;
    tituloBoton: string;
    tituloMultimedia: string;
    videoUrl: null | string;
    video: null;
    parentSlug?: string;
}

const digitalSkillSlug = "competencias-digitales";

function shuffleArray<T>(array: T[]) {
    return array.sort(() => Math.random() - 0.5);
}

const getAllBlogPost = (subCategory: any[], parentSlug: string) => {
    return subCategory?.flatMap((subCategoryData) => ({
        slug: subCategoryData?.slug,
        postData: {
            ...(subCategoryData?.referenciaInterna?.referenciaCabecera
                ?.referenciaMultimedia || {}),
            parentSlug,
            slug: subCategoryData?.slug,
        },
    }));
};

export const useCeidRecomendation = () => {
    const queryResult = useStaticQuery(graphql`
        query GetLibraryContent {
            data: contentfulSubcategorias(
                contentful_id: { eq: "7KHkTe0HcCUf8Xhn7NvwGC" }
            ) {
                referenciaSubcategorias {
                    slug
                    referenciaSubcategorias {
                        slug
                        referenciaInterna {
                            referenciaCabecera {
                                migaDePan
                                referenciaMultimedia {
                                    audioUrl
                                    autor
                                    categoriaMultimedia
                                    contentful_id
                                    createdAt
                                    descripcion {
                                        raw
                                    }
                                    imagenPrincipal {
                                        gatsbyImageData(
                                            layout: CONSTRAINED
                                            outputPixelDensities: [0.5, 1, 2]
                                            breakpoints: [320, 768, 1024, 1440]
                                            placeholder: BLURRED
                                            sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                        )
                                        description
                                    }
                                    tematica
                                    textoIntroductorio
                                    tiempoLectura
                                    tituloBoton
                                    tituloMultimedia
                                    videoUrl
                                    video {
                                        file {
                                            url
                                            fileName
                                            contentType
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const subCategories = queryResult?.data?.referenciaSubcategorias || [];
    const digitalSkill = subCategories.find((subCategory) =>
        subCategory?.slug?.includes(digitalSkillSlug)
    );

    const digitalSkillsPosts: {
        slug: string;
        postData: ReferenciaMultimedia;
    }[] = getAllBlogPost(
        digitalSkill?.referenciaSubcategorias || [],
        digitalSkill?.slug
    );

    return {
        digitalSkill: shuffleArray(digitalSkillsPosts)?.slice(0, 3),
        subCategories,
        digitalSkillsPosts,
    };
};
